import { Button, Input, Select } from 'antd'
import React, { useState } from 'react'
import styled from 'styled-components'
import { GeckoComponent } from 'types'

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem;
  background: ${({ theme }) => theme.forecast.cardBackground};
  border-radius: 0.375rem;
`

const FormRow = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`

const ButtonRow = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
`

interface CreateDeficiencyFormProps {
  components: readonly GeckoComponent[]
  onSubmit: (data: {
    title: string
    description?: string
    componentId?: string
  }) => void
  onCancel: () => void
}

export const CreateDeficiencyForm: React.FC<CreateDeficiencyFormProps> = ({
  components,
  onSubmit,
  onCancel,
}) => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [componentId, setComponentId] = useState<string | undefined>()

  const handleSubmit = () => {
    if (!title.trim()) {
      return
    }

    onSubmit({
      title: title.trim(),
      description: description.trim() || undefined,
      componentId,
    })

    // Reset form
    setTitle('')
    setDescription('')
    setComponentId(undefined)
  }

  const componentOptions = components.map((comp) => ({
    value: comp.id,
    label: comp.data.name,
  }))

  return (
    <FormContainer>
      <FormRow>
        <Input
          placeholder='Deficiency title'
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onPressEnter={handleSubmit}
          autoFocus
        />
      </FormRow>
      <FormRow>
        <Input.TextArea
          placeholder='Description (optional)'
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={2}
        />
      </FormRow>
      <FormRow>
        <Select
          style={{ flex: 1 }}
          placeholder='Component (optional)'
          value={componentId}
          onChange={setComponentId}
          options={componentOptions}
          allowClear
          showSearch
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
        />
      </FormRow>
      <ButtonRow>
        <Button onClick={onCancel}>Cancel</Button>
        <Button type='primary' onClick={handleSubmit} disabled={!title.trim()}>
          Add Deficiency
        </Button>
      </ButtonRow>
    </FormContainer>
  )
}
